import {
  chakra,
  forwardRef,
  type TableBodyProps as ChakraTbodyProps,
} from '@chakra-ui/react';

import { useTableStyles } from '../TableStylesContext';

export type TbodyProps = ChakraTbodyProps;

export const Tbody = forwardRef<TbodyProps, 'tbody'>((props, ref) => {
  const { tbody: tbodyStyles } = useTableStyles() ?? {};

  return <chakra.tbody {...props} ref={ref} __css={tbodyStyles} />;
});
